import axios from 'axios';
import { verifyEnvUrl } from 'util/verifyEnvUrl';

const prdURL = 'https://bailey-api-263680973121.southamerica-east1.run.app';
const devURL = 'https://bailey-api-dev-263680973121.southamerica-east1.run.app';
// const devURL = 'http://localhost:3001';

const pipegoAPi = axios.create( {
	baseURL: verifyEnvUrl( prdURL,devURL )
} );
pipegoAPi.interceptors.request.use( async config => {
	const token = localStorage.getItem( 'af-token' );
	if ( token ) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
} );


export default pipegoAPi;
